<template>
  <router-link
    role="button"
    :class="{ 'course': true, 'private': is_private, 'draft': course.draft, 'undetermined': course.undetermined }"
    :to="{ name: ROUTE_COURSE_VIEW, params: { id: course.id } }">
    <div class="header">
      <div class="time" v-html="time_title" />
      <div class="actions">
        <a role="button" class="btn btn-primary" v-if="course.draft">审核</a>
        <router-link role="button" class="btn btn-primary" v-if="course.undetermined" :to="{ name: ROUTE_COURSE_VIEW, params: { id: course.id} }">设置</router-link>
      </div>
      <a role="button" class="close" @click.stop.prevent="deleteCourse">&times;</a>
    </div>
    <div class="body">
      <div class="content">
        <div v-if="course.user_avatar" class="avatar">
          <img :src="course.user_avatar" >
        </div>
        <div class="desc">
          <div class="title">
            <div class="user_name">{{ course.user_name }}</div>
            <div class="labels" v-if="course.has_trainer">
              <div v-if="!course.wechat_bound" class="label negative">未绑定</div>
              <div v-if="course.notified" class="label positive">已通知</div>
              <div v-else class="label negative">未通知</div>
              <div v-if="course.closed" class="label positive">已完成</div>
            </div>
          </div>
          <div class="content-line">
            <label>内容：</label>{{ course.content }}
          </div>
          <div class="content-line">
            <label>备注：</label>{{ course.comment }}
          </div>
        </div>
      </div>
      <div v-if="course.has_trainer && !(course.wechat_bound && course.notified)" class="actions">
        <router-link role="button" class="btn btn-primary" v-if="!course.notified" :to="{ name: ROUTE_COURSE_NOTIFICATION, params: { id: course.id } }">通知</router-link>
        <router-link role="button" class="btn btn-default" v-if="!course.wechat_bound" type="default" :to="{ name: ROUTE_COURSE_NOTIFICATION, params: { id: course.id } }">绑定</router-link>
      </div>
    </div>
  </router-link>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import weui from '@/wechat/weui';

import { WeuiButton, WeuiButtonArea } from '@/components/weui';
import { COURSE_TYPE_PRIVATE } from '@/constants/types';
import dtos from '@/dtos/course';
import { ROUTE_COURSE_VIEW, ROUTE_COURSE_NOTIFICATION, ROUTE_PERIODIC_COURSE_DELETING } from '@/router/names';
import { DELETE_COURSE } from '@/store/course/types';

const { mapActions } = createNamespacedHelpers('course');

export default {
    name: 'Course',
    props: {
        course: {
            type: [Object, Array],
            required: true,
            default: () => ({
                id: 0,
                type: 0,
                undetermined: false,
                start_time: '00:00',
                end_time: '01:00',
                user_name: '测试',
                user_avatar: 'http://wx.qlogo.cn/mmopen/vi_32/PiajxSqBRaELnoyxCufmVGX2vHaAicnx2km4NiaRKKp4v80Zziack9sPY4mCwQjpOvAzWDx0ZQRpmqV0elChiajq2eA/132',
                content: '测试私人事件',
                comment: '测试备注信息',
                comment_publicly: true,
                draft: false,
                wechat_bound: true,
                notified: true,
            }),
        },
    },
    data() {
        return {
            ROUTE_COURSE_VIEW,
            ROUTE_COURSE_NOTIFICATION,
        };
    },
    computed: {
        time_title() {
            let time = this.course.start_time;
            if (!time) {
                time = '待定';
            }
            // 保证只有时分
            time = time.substr(0, 5);
            if (this.course.draft) {
                time = `约课${time}`;
            }

            return time;
        },
        is_private() {
            return this.course.type === COURSE_TYPE_PRIVATE;
        },
    },
    methods: {
        ...mapActions({
            apiDelete: DELETE_COURSE,
        }),
        async deleteCourse() {
            if (dtos.periodic(this.course)) {
                this.$router.push({
                    name: ROUTE_PERIODIC_COURSE_DELETING,
                    params: {
                        id: this.course.id,
                    },
                });
            } else if (await weui.confirm('课程删除后无法恢复，确认删除吗？')) {
                await this.apiDelete({ id: this.course.id });
                await weui.toast('删除成功');
                this.$router.go(0);
            }
        },
    },
    components: {
        WeuiButtonArea,
        WeuiButton,
    },
};
</script>

<style lang="scss" scoped>
$color: #a4c787;
$bg-color: #e8eee4;
$private-color: #e7bc60;
$private-bg-color: #f3efd3;
$draft-color: #ff7f55;
$draft-bg-color: #ffe2d7;
$undetermined-color: #ff7f55;
$undetermined-bg-color: #ffe2d7;

.course {
    color: #000;
}


.btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16vw;
    height: 8vw;
    border-radius: 0.8vw;
    box-sizing: border-box;
    font-size: 3.466666667vw;
}

.btn + .btn {
    margin-left: 4vw;
}

.btn-primary {
    background-color: #1aad19;
    color: white;
    border: solid 1px rgba(5, 5, 5, 0.08);
}

.btn-default {
    border: solid 2px #1aad19;
    color: #1aad19;
}

.header {
    display: flex;
    align-items: center;

    .actions {
        flex: auto;
        display: flex;
        justify-content: flex-end;
        padding-right: 4vw;
    }
}

.time {
    flex: none;
    margin-left: 4vw;
    font-family: Arial;
    font-size: 10.666666667vw;
    line-height: 1;
    color: $color;

    .private & {
        color: $private-color;
    }

    .draft & {
        color: $draft-color;
    }

    .undetermined & {
        color: $undetermined-color;
    }
}

.close {
    width: 11.2vw;
    height: 6.4vw;
    flex: none;
    border-left: 1px solid #d2d0d0;
    display: flex;
    justify-content: center;
    font-size:  4vw;
    line-height: 6.4vw;
    color: #bdbdbd;
}

.body {
    box-sizing: border-box;
    border-top: 4px solid $color;
    background-color: $bg-color;

    .private & {
        border-top: 4px solid $private-color;
        background-color: $private-bg-color;
    }

    .draft & {
        border-top: 4px solid $draft-color;
        background-color: $draft-bg-color;
    }

    .undetermined & {
        border-top: 4px solid $undetermined-color;
        background-color: $undetermined-bg-color;
    }

    .actions {
        margin: 0 4vw;
        padding: 3.333333333vw 0 3.333333333vw 0.8vw;
        border-top: 1px solid #a4c787;
        display: flex;
        align-items: center;
    }
}

.content {
    display: flex;
    padding-top: 4vw;
    padding-bottom: 4vw;
}

.avatar {
    margin-left: 4.8vw;
    display: flex;
    justify-content: center;

    > img {
        box-sizing: border-box;
        width: 25.333333333vw;
        height: 25.333333333vw;
        border: solid 4px #ffffff
    }
}

.desc {
    margin-left: 4.8vw;
}

.title {
    display: flex;
    align-items: center;
    font-size: 4.8vw;
    line-height: 1.4;
}

.content-line {
    margin-top: 1.6vw;
    color: #9b9b9b;
    font-size: 3.466666667vw;
    line-height: 1.4;
}

.labels {
    display: flex;
    align-items: center;
}

.label {
    width: 12vw;
    font-size: 2.933333333vw;
    line-height: 5vw;
    margin-left: 2.666666667vw;
    text-align: center;

    &.positive {
        color: #87a56f;
        background-color: #d3ecbe;
        border: solid 1px #bbd6a5;
    }

    &.negative {
        color: #874a29;
        background-color: #e4c198;
        border: solid 1px #ca975c;
    }
}


</style>



// WEBPACK FOOTER //
// src/components/calendar/Course.vue